import { render, staticRenderFns } from "./RawMaterialDetail.vue?vue&type=template&id=303f6e6e&"
import script from "./RawMaterialDetail.vue?vue&type=script&lang=js&"
export * from "./RawMaterialDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports